define([], function() {
    return {
        init: function() {
            const _this = this;

            this.on('change-design', function(params) {
                _this.model.set(params, { merge: true, remove: false });
                _this.model.trigger('changed');
            });

            this.on('change:option', function(optionsContext) {
                _this.model.get('optionsContext').set(optionsContext || {}, { merge: true, remove: false });
            });
        }
    };
});
